import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { getActiveTemplate } from '../templates/registry';
import { useBrandConfig } from '../context/BrandConfigContext';
import Error404 from '../pages/Error404';

const AppRoutes = () => {
  const brand = useBrandConfig();
  const { pages } = getActiveTemplate(brand?.active_template_key);
  const { Entry, FAQ, TermsAndConditions, EveryBodyWins, Profile, Cart } = pages;

  return (
    <Routes>
      {/* Root route - always go straight to Entry */}
      <Route path="/" element={<Entry />} />

      {/* Welcome disabled — always redirect back home, never render Welcome */}
      <Route path="/welcome" element={<Navigate to="/" replace />} />
      <Route path="/faqs" element={<FAQ />} />
      <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
      <Route path="/everybody-wins" element={<EveryBodyWins />} />
      {/* Only templates that define these pages (e.g. "magic") expose them — others 404 */}
      {Profile && <Route path="/profile" element={<Profile />} />}
      {Cart && <Route path="/cart" element={<Cart />} />}
      {/* Error Pages */}
      <Route path="/404" element={<Error404 />} />
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
};

export default AppRoutes;

